import { ImportCustomerTypeField } from "../../../features/importer"
import { DocumentPaymentTypeIdsData, SettingsModule, useSettingsLoaders } from "../../administration"
import { useBudgetLoaders } from "../loaders/budgetLoaders"
import { useCustomerLoaders } from "../loaders/customerLoaders"
import { useSaleOperationLoaders } from "../loaders/saleOperationLoaders"

export const useCustomerTypeHooks = () => {
    const customerLoaders = useCustomerLoaders()
    const budgetLoaders = useBudgetLoaders()
    const saleOperationLoaders = useSaleOperationLoaders()
    const settingsLoaders = useSettingsLoaders()

    const canRemoveCustomerType = async (customerTypeId: string): Promise<boolean> => {
        const { countCustomers2 } = customerLoaders()
        const customersCount = await countCustomers2('customerTypeId', customerTypeId)
        
        const { countBudgets } = budgetLoaders()
        const budgetsCount = await countBudgets('customerTypeId', customerTypeId)

        const { countSaleOperations } = saleOperationLoaders()
        const saleOperationsCount = await countSaleOperations('customerTypeId', customerTypeId)

        const { loadModuleSettings } = settingsLoaders()
        const saleSettings = await loadModuleSettings(SettingsModule.SALES)
        const inSettings = Object.values(saleSettings.documentPaymentTypeIds || {}).some((documentPaymentTypeIdsData: DocumentPaymentTypeIdsData) =>
            Object.keys(documentPaymentTypeIdsData).some(key => key === customerTypeId)
        )

        return customersCount === 0 &&
            budgetsCount === 0 &&
            saleOperationsCount === 0 &&
            !inSettings
    }

    return {
        canRemoveCustomerType
    }
}

export const customerTypeHelpers = {
    getTemplateSubPath: (priceFieldValue: ImportCustomerTypeField) => {
        return `templates/customerTypes/${priceFieldValue}/ListaPrecios.csv`
    }
}
